import React from 'react';
import './ratings.css';

const getStarRating = (percentage) => {
    const rating = parseFloat(percentage);
    return Array.from({ length: 5 }, (_, index) => {
        if (index < Math.floor(rating)) {
            return "full";
        } else if (index < rating) {
            return "half";
        } else {
            return "empty";
        }
    });
};

export const Ratings = ({ percentage }) => {
    const stars = getStarRating(percentage);

    return (
        <div className="ratings">
            {stars.map((type, index) => (
                <div key={index} className={`star ${type}`} />
            ))}
        </div>
    );
};
